import { applyTokens } from "../../../utilities/applyTokens.js";
const badge = (tokens) => {
    const { badge } = tokens.component;
    return {
        MuiBadge: {
            defaultProps: {
                color: "new",
            },
            styleOverrides: {
                root: ({ ownerState }) => ({
                    "& .MuiBadge-badge": Object.assign(Object.assign(Object.assign(Object.assign({ fontWeight: badge.fontWeight.value }, (((ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "standard" ||
                        (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "inlineStandard") && {
                        fontSize: badge.large.fontSize.value,
                        height: badge.large.height.value,
                        minWidth: badge.large.width.value,
                        borderRadius: badge.large.height.value,
                        paddingLeft: badge.large.paddingHorizontal.value,
                        paddingRight: badge.large.paddingHorizontal.value,
                    })), (((ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "counter" || (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "inlineCounter") && Object.assign(Object.assign({}, applyTokens(badge.counter)), { minWidth: "unset", borderStyle: "solid", height: badge.counter.large.height.value, fontSize: badge.counter.large.fontSize.value }))), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "dot" && {
                        width: badge.indicator.width.value,
                        height: badge.indicator.height.value,
                    })), (((ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "inlineStandard" ||
                        (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "inlineCounter") && {
                        position: "relative",
                        transform: "none",
                    })),
                }),
            },
        },
    };
};
export default badge;
//# sourceMappingURL=badge.js.map